import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

const moduleSelector = '.timeline-slide';

const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" aria-hidden="true"><rect width="56" height="56" rx="28" fill="currentColor"/><path d="M39.5779 29.0171L30.9394 37.6556C30.6689 37.9261 30.3021 38.078 29.9196 38.078C29.5371 38.078 29.1702 37.9261 28.8997 37.6556C28.6293 37.3851 28.4773 37.0183 28.4773 36.6358C28.4773 36.2532 28.6293 35.8864 28.8997 35.6159L35.0799 29.4382H17.4429C17.0611 29.4382 16.6949 29.2865 16.4249 29.0165C16.1549 28.7465 16.0032 28.3803 16.0032 27.9984C16.0032 27.6166 16.1549 27.2504 16.4249 26.9804C16.6949 26.7104 17.0611 26.5587 17.4429 26.5587H35.0799L28.9021 20.3774C28.6317 20.1069 28.4797 19.74 28.4797 19.3575C28.4797 18.975 28.6317 18.6082 28.9021 18.3377C29.1726 18.0672 29.5395 17.9153 29.922 17.9153C30.3045 17.9153 30.6713 18.0672 30.9418 18.3377L39.5803 26.9762C39.7146 27.1102 39.821 27.2693 39.8936 27.4445C39.9662 27.6197 40.0034 27.8075 40.0032 27.9971C40.003 28.1868 39.9653 28.3745 39.8923 28.5495C39.8193 28.7246 39.7125 28.8834 39.5779 29.0171Z" fill="white"/></svg>';

const getImageSrc = (img) => img?.url ?? (typeof img === 'string' ? img : '');

const getItemImages = (item) => {
  const raw = item.image;
  if (!raw) return [];
  const list = Array.isArray(raw) ? raw : Object.values(raw);
  return list.map(getImageSrc).filter(Boolean);
};

const buildImageMarkup = (images, alt) => {
  if (!images.length) return '';

  if (images.length === 1) {
    return `<img src="${images[0]}" alt="${alt}" loading="lazy">`;
  }

  const slides = images.map((src) => `
    <li class="splide__slide">
      <img src="${src}" alt="${alt}" loading="lazy">
    </li>
  `).join('');

  return `
    <div class="timeline-slide__image-slider splide">
      <div class="splide__track">
        <ul class="splide__list">${slides}</ul>
      </div>
    </div>
  `;
};

(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((section) => {
    const nav = section.querySelector('.timeline-slide__nav');
    const sliderEl = section.querySelector('.timeline-slide__slider.splide');
    const contentList = sliderEl?.querySelector('.splide__list');

    if (!nav || !sliderEl || !contentList) return;

    try {
      section.querySelector('script')?.remove();
      const { data } = dJSON.parse(section.data);
      if (!Array.isArray(data) || !data.length) return;

      const line = document.createElement('div');
      line.className = 'timeline-slide__nav__line';
      nav.appendChild(line);

      const navSplideEl = document.createElement('div');
      navSplideEl.className = 'timeline-slide__nav__track splide';

      const navTrack = document.createElement('div');
      navTrack.className = 'splide__track';

      const navList = document.createElement('ul');
      navList.className = 'splide__list';

      const yearButtons = [];
      const imageSplides = [];
      const contentFragment = document.createDocumentFragment();

      data.forEach((item, i) => {
        // nav year slide
        const navSlide = document.createElement('li');
        navSlide.className = 'splide__slide';

        const btn = document.createElement('button');
        btn.className = 'timeline-slide__nav__year';
        if (i === 0) btn.classList.add('is-active', 'is-passed');
        btn.type = 'button';
        btn.innerHTML = `<span class="timeline-slide__nav__dot"></span><span class="timeline-slide__nav__label">${item.year || ''}</span>`;

        navSlide.appendChild(btn);
        navList.appendChild(navSlide);
        yearButtons.push(btn);

        // content slide
        const images = getItemImages(item);
        const alt = item.title || '';
        const contentSlide = document.createElement('li');
        contentSlide.className = 'splide__slide';
        contentSlide.innerHTML = /* html */ `
          <div class="timeline-slide__content">
            <div class="timeline-slide__text">
              <h2 class="timeline-slide__text__heading">${item.title || ''}</h2>
              <p class="timeline-slide__text__body">${item.text || ''}</p>
            </div>
            <div class="timeline-slide__image">
              ${buildImageMarkup(images, alt)}
            </div>
          </div>
        `;
        contentFragment.appendChild(contentSlide);
        imageSplides.push(null);
      });

      navTrack.appendChild(navList);
      navSplideEl.appendChild(navTrack);
      nav.appendChild(navSplideEl);
      contentList.appendChild(contentFragment);

      const splide = new Splide(sliderEl, {
        type: 'fade',
        arrows: true,
        pagination: false,
        height: 460,
        speed: 500,
        drag: false,
        breakpoints: {
          768: { height: 600 },
        },
      });

      const navSplide = new Splide(navSplideEl, {
        type: 'slide',
        perPage: 1,
        arrows: false,
        pagination: false,
        speed: 500,
        drag: true,
        mediaQuery: 'min',
        breakpoints: {
          769: { drag: false },
        },
      });

      const setArrowIcons = () => {
        const prevBtn = sliderEl.querySelector(':scope > .splide__arrows .splide__arrow--prev');
        const nextBtn = sliderEl.querySelector(':scope > .splide__arrows .splide__arrow--next');
        if (prevBtn) prevBtn.innerHTML = arrowSvg;
        if (nextBtn) nextBtn.innerHTML = arrowSvg;
      };

      // Nested image splides trigger a parent refresh that repositions arrows via inline styles
      const resetMainArrows = () => {
        sliderEl.querySelectorAll(':scope > .splide__arrows .splide__arrow').forEach((btn) => {
          btn.removeAttribute('style');
        });
        setArrowIcons();
      };

      const mountImageSplides = () => {
        [...contentList.children].forEach((slide, i) => {
          const imageSliderEl = slide.querySelector('.timeline-slide__image-slider.splide');
          if (!imageSliderEl) return;

          const imageSplide = new Splide(imageSliderEl, {
            type: 'fade',
            arrows: false,
            height: '100%',
            pagination: true,
            speed: 400,
            drag: true,
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
          });

          imageSplide.mount();
          imageSplides[i] = imageSplide;
        });
      };

      const isMobile = () => window.innerWidth <= 768;

      const updateProgress = (index) => {
        if (isMobile()) {
          const progress = data.length > 1 ? index / (data.length - 1) : 0;
          line.style.width = `${progress * 100}%`;
        } else {
          const dot = yearButtons[index].querySelector('.timeline-slide__nav__dot');
          const navRect = nav.getBoundingClientRect();
          const dotRect = dot.getBoundingClientRect();
          const dotCenter = dotRect.left + dotRect.width / 2;
          const lineStart = navRect.left + navRect.width / 2 - window.innerWidth / 2;
          line.style.width = `${dotCenter - lineStart}px`;
        }
      };

      const updateActiveYear = (index) => {
        yearButtons.forEach((btn, i) => {
          btn.classList.toggle('is-active', i === index);
          btn.classList.toggle('is-passed', i <= index);
        });
        updateProgress(index);
      };

      splide.on('moved', (newIndex) => {
        updateActiveYear(newIndex);
        imageSplides.forEach((imageSplide, i) => {
          if (!imageSplide) return;
          if (i === newIndex) {
            imageSplide.go(0);
            imageSplide.Components.Autoplay?.play();
          } else {
            imageSplide.Components.Autoplay?.pause();
          }
        });
        if (isMobile() && navSplide.index !== newIndex) navSplide.go(newIndex);
      });

      splide.on('resize updated', () => {
        requestAnimationFrame(resetMainArrows);
      });

      navSplide.on('move', (newIndex) => {
        updateActiveYear(newIndex);
        if (splide.index !== newIndex) splide.go(newIndex);
      });

      let navDragging = false;
      let navDragRaf;

      const trackNavDrag = () => {
        if (!navDragging || !isMobile()) return;
        const listEl = navSplideEl.querySelector('.splide__list');
        if (listEl) {
          const style = getComputedStyle(listEl).transform;
          const matrix = style && style !== 'none' ? new DOMMatrix(style) : new DOMMatrix();
          const slideEl = navSplideEl.querySelector('.splide__slide');
          const slideWidth = slideEl ? slideEl.offsetWidth : 1;
          const fractionalIndex = Math.max(0, Math.min(data.length - 1, -matrix.m41 / slideWidth));
          const progress = data.length > 1 ? fractionalIndex / (data.length - 1) : 0;
          line.style.width = `${progress * 100}%`;
        }
        navDragRaf = requestAnimationFrame(trackNavDrag);
      };

      const stopNavDrag = () => {
        if (!navDragging) return;
        navDragging = false;
        cancelAnimationFrame(navDragRaf);
        line.style.transition = '';
      };

      navSplideEl.addEventListener('pointerdown', () => {
        if (!isMobile()) return;
        navDragging = true;
        line.style.transition = 'none';
        navDragRaf = requestAnimationFrame(trackNavDrag);
      });

      window.addEventListener('pointerup', stopNavDrag);
      window.addEventListener('pointercancel', stopNavDrag);

      splide.mount();
      navSplide.mount();
      setArrowIcons();
      mountImageSplides();
      resetMainArrows();
      updateActiveYear(0);

      imageSplides.forEach((imageSplide, i) => {
        if (imageSplide && i !== 0) imageSplide.Components.Autoplay?.pause();
      });

      yearButtons.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          splide.go(i);
          if (isMobile()) navSplide.go(i);
        });
      });

      let resizeRaf;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => {
          const idx = splide.index;
          updateProgress(idx);
          resetMainArrows();
          if (isMobile() && navSplide.index !== idx) navSplide.go(idx);
        });
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
